module.exports = __webpack_public_path__ + "img/4.d8fd197f.png";